export const SHOW_ESCAPE_HATCH = 'SHOW_ESCAPE_HATCH';
export const HIDE_ESCAPE_HATCH = 'HIDE_ESCAPE_HATCH';
